// Single source of truth for narrative entries
export interface NarrativeEntry {
  key: string;
  texts: string[];
  delay?: number; // Optional, defaults to 2000ms
}

// Define all narrative content in one array - no duplicate keys!
export const narrativeSequence: NarrativeEntry[] = [
  // Intro sequence - sets the stage
  {
    key: "intro.line1",
    texts: [
      "Crypto is a warzone. Millions fight for attention, liquidity, and alpha in a 24/7 global battle royale.",
      "Most traders would have a better chance of picking winners if they bought a lottery ticket...",
      "...and most tokens would have a better chance at survival if they hatched as sea turtles!",
      "But here, they battle in the spotlight for their shot at wealth and glory!",
    ],
    delay: 500,
  },

  // Bracket sequence - tournament overview
  {
    key: "bracket.liquidity",
    texts: [
      "512 tokens entered this tournament with only $5 to their name. After 8 elimination rounds, only two remain.",
      "They've accumulated over $40k from spectating fans and defeated competitors.",
      "The final battle has already begun... Let's go!",
    ],
    delay: 500,
  },
  // Versus screen transition
  {
    key: "bracket.versus",
    texts: [""],
    delay: 0,
  },
  // Finals sequence - the battle with user interaction
  {
    key: "finals.start",
    texts: [
      "This is the Arena. Two tokens enter, one token leaves.",
      "Spectators buy stakes in their token of choice. At the top is their total liquidity. When time runs out, whoever has the most will drain the loser.",
    ],
    delay: 500,
  },
  {
    key: "finals.betting",
    texts: [
      "We got here just in time. It looks like {{loser}} has a thin lead with only seconds to go.",
      "You can see support coming in live. Place your own by tapping the arena on the side you favor. Higher up buys a larger stake.",
    ],
    delay: 500,
  },
  {
    key: "finals.rally",
    texts: [
      "!!!!",
      "{{winner}} is rallying hard in the final moments! Will it be enough?",
    ],
    delay: 2000,
  },
  {
    key: "finals.victory",
    texts: [
      "{{winner}} has stolen the victory! An exciting finish to this tournament. Its supporters are sharing a big prize.",
      "The Arena will open to the public soon. Do you have what it takes to pick a champion — or be one?",
    ],
    delay: 500,
  },

  // // Champion sequence - tournament winner showcase
  {
    key: "champion.winner",
    texts: ["{{winner}} has emerged victorious!"],
    delay: 2000,
  },

  // // Reveal sequence - the pitch
  // {
  //   key: "reveal.problem",
  //   texts: ["Blah blah blah, blah blah blah"],
  //   delay: 2000,
  // },
  // {
  //   key: "reveal.solution",
  //   texts: [
  //     "Discovery through competition. Engagement through stakes. Winners proven by market.",
  //   ],
  //   delay: 2000,
  // },
  // {
  //   key: "reveal.cta",
  //   texts: ["Pre-seed: $250K to ship v1. [Schedule 15min] [See Deck]"],
  //   delay: 0,
  // },
];

// Derived data structures for efficient lookup
export const narrativeKeys = narrativeSequence.map((entry) => entry.key);

const narrativeMap = new Map(
  narrativeSequence.map((entry) => [entry.key, entry])
);

export function getNarrativeTexts(key: string): string[] {
  return narrativeMap.get(key)?.texts || [`[Missing narrative: ${key}]`];
}

export function getNarrativeDelay(key: string): number {
  return narrativeMap.get(key)?.delay ?? 2000; // Default to 2 seconds
}

export function processNarrativeText(
  text: string,
  variables: Record<string, any>
): string {
  return text.replace(/\{\{(\w+)\}\}/g, (_, key) => {
    const value = variables[key];
    if (value === undefined) {
      console.warn(`Missing narrative variable: ${key}`);
      return `{{${key}}}`;
    }
    return String(value);
  });
}
